import { createLogger } from "@/infra/logging/logger";

export const rewardedLog = createLogger("ADMOB");
